import { Immutable } from "immer";
import React from "react";

import {
    CompareFeatureBlock,
    TsicommonCmsCompareFeatureOrNull,
} from "@reactivated";

import { Image } from "../Image";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

type IProps = Immutable<{
    feature: TsicommonCmsCompareFeatureOrNull;
    content: (CompareFeatureBlock | null)[] | undefined;
}>;

export const CompareFeatureRow = (props: IProps): React.JSX.Element | null => {
    if (!props.content) {
        return null;
    }
    return (
        <div className={styles.compareFeatureRowContainer}>
            {props.content.map((item, index) => (
                <div
                    key={
                        item?.feature?.title
                            ? `${item.feature.title}-${index}`
                            : `empty-${index}`
                    }
                    className={styles.contentContainer}
                >
                    {item?.icon ? (
                        <Image
                            src={item.icon.url}
                            alt={
                                item.feature
                                    ? item.feature.title
                                    : "Compare Row Icon"
                            }
                            className={styles.icon}
                        />
                    ) : (
                        <div aria-hidden="true" className={styles.iconEmpty} />
                    )}
                    {item?.feature && item.description ? (
                        <RichText html={item.description || "_"} />
                    ) : (
                        <div
                            aria-hidden="true"
                            className={styles.descriptionEmpty}
                        >
                            –
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
